export const REGISTRY_NAV_HEIGHT = '76px';
export const ADMIN_MANAGE_PAGE_TAB_QUERY_PARAM = 'mtabs';
export const ORDER_NUMBER_QUERY_PARAM = 'orderNumber';
export const SPUR_EXPERIENCES_BRAND = 'Spur Experiences';
export const REGISTRY_SHIPPING_THRESHOLD = 75;
